import { createApiSlice } from "@common";
import { CRUD_EMPLOYEE_RECORD_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addEmployeeRecordStatus",
    method: "post",
    url: CRUD_EMPLOYEE_RECORD_STATUS,
    stateKey: "message"
  },
  {
    name: "getEmployeeRecordStatus",
    method: "get",
    url: CRUD_EMPLOYEE_RECORD_STATUS,
    stateKey: "data"
  },
  {
    name: "updateEmployeeRecordStatus",
    method: "put",
    url: CRUD_EMPLOYEE_RECORD_STATUS,
    stateKey: "message"
  },
  {
    name: "deleteEmployeeRecordStatus",
    method: "delete",
    url: CRUD_EMPLOYEE_RECORD_STATUS,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "employeeDocuments",
  apiConfig,
  customReducers
);
const employeeRecordStatusSlice = slice;

export default employeeRecordStatusSlice.reducer;

export const {
  addEmployeeRecordStatus,
  getEmployeeRecordStatus,
  updateEmployeeRecordStatus,
  deleteEmployeeRecordStatus
} = thunks;
export const { rowSelect } = actions;
